import { render, staticRenderFns } from "./bindAccout.vue?vue&type=template&id=45821c22&scoped=true&"
import script from "./bindAccout.vue?vue&type=script&lang=ts&"
export * from "./bindAccout.vue?vue&type=script&lang=ts&"
import style0 from "./bindAccout.vue?vue&type=style&index=0&id=45821c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45821c22",
  null
  
)

export default component.exports